module.exports = __webpack_public_path__ + "img/comment-sms.1aac641c.svg";